/**
 * Hook for loading ticker announcements
 */

import { useState, useEffect } from 'react';
import type { TickerAnnouncement } from '../types';

export function useAnnouncements() {
  const [announcements, setAnnouncements] = useState<TickerAnnouncement[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    async function loadAnnouncements() {
      try {
        const response = await fetch('/data/announcements.json');
        if (!response.ok) throw new Error('Failed to load announcements');
        const data = await response.json();
        setAnnouncements(data);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Unknown error'));
      } finally {
        setLoading(false);
      }
    }

    loadAnnouncements();
  }, []);

  return { announcements, loading, error };
}
